// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"41":"9162d3ee","225":"0530767d","754":"71299d32","756":"0530767d"}[chunkId] + ".chunk.css";
};